import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "initial-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "app-main"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorNotification = _resolveComponent("ErrorNotification")!
  const _component_OnboardingModal = _resolveComponent("OnboardingModal")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg-pattern" }, null, -1)),
    _createVNode(_component_ErrorNotification, {
      message: _ctx.errorMessage,
      onClose: _ctx.clearError
    }, null, 8, ["message", "onClose"]),
    _createVNode(_component_OnboardingModal, {
      modelValue: _ctx.showOnboardingModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showOnboardingModal) = $event))
    }, null, 8, ["modelValue"]),
    (_ctx.isInitializing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoadingSpinner, { size: "lg" })
        ]))
      : (_openBlock(), _createElementBlock("main", _hoisted_2, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]))
  ], 64))
}